import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./Navbar";
import Carousel from "./Carousel";
import Announcements from "./Announcements";
import Footer from "./Footer";
import Login from "./Login";
import AdminPanel from "./AdminPanel";
import ProtectedRoute from "./ProtectedRoute";
import { supabase } from "./supabaseClient";
import AboutUs from "./AboutUs";
import Yonetim from "./Yonetim";
import DynamicContent from "./DynamicContent";

function App() {
  const [isAuth, setIsAuth] = useState(false); // Kullanıcı giriş durumunu tutar
  const [headings, setHeadings] = useState([]); // Supabase'den gelen başlıkları tutar
  const [loading, setLoading] = useState(true); // Yükleme durumu

   // Supabase'den başlıkları ve içerikleri çekmek
   useEffect(() => {
    const fetchHeadings = async () => {
      const { data, error } = await supabase.from("headings").select("*");
      if (error) {
        console.error("Başlıklar alınırken hata oluştu:", error);
      } else {
        setHeadings(data);
        setLoading(false);
      }
    };
    fetchHeadings();
  }, []);

  // Yüklenme sırasında mesaj göster
  if (loading) {
    return <div>Yükleniyor...</div>;
  }
  return (
    <Router>
      {/* Tüm Sayfayı Kapsayan Yapı */}
      <div id="root">
        <Navbar />
        <div className="main-content">
          <Routes>
            {/* Ana Sayfa */}
            <Route
              path="/"
              element={
                <>
                  <Carousel />
                  <div className="container">
                    <h2 className="announcements-heading">📢DUYURULAR</h2>
                    <Announcements />
                  </div>
                </>
              }
            />

            <Route path="/admin" element={<Login setIsAuth={setIsAuth} />} />
               {/* Admin Paneli - Korunan Rota */}
            <Route
              path="/admin-panel"
              element={
                <ProtectedRoute isAuth={isAuth}>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />

            {/* Hakkımızda Alt Başlıkları */}
            {/* Hakkımızda - Biz Kimiz Dinamik Başlığı */}
<Route
  path="/hakkimizda/biz-kimiz"
  element={
    <AboutUs /> // Dinamik içerik bileşeni
  }
/>
<Route
  path="/hakkimizda/yonetim"
  element={<Yonetim subtitle="Yönetim" />}
/>
<Route
  path="/hakkimizda/organizasyon"
  element={<DynamicContent title="Hakkımızda" subtitle="Organizasyon Şemamız" />}
/>
<Route
  path="/hakkimizda/kalite"
  element={<DynamicContent title="Hakkımızda" subtitle="Kalite Politikamız" />}
/>
<Route
  path="/hakkimizda/misyon"
  element={<DynamicContent title="Hakkımızda" subtitle="Misyonumuz" />}
/>
<Route
  path="/hakkimizda/vizyon"
  element={<DynamicContent title="Hakkımızda" subtitle="Vizyonumuz" />}
/>
            {/* Birimlerimiz Alt Başlıkları */}
            <Route
  path="/birimler/kalite-yonetim"
  element={
    <DynamicContent title="Birimlerimiz" subtitle="Kalite Yönetim Birimi" />
  }
/>
<Route
  path="/birimler/numune-kabul"
  element={
    <DynamicContent title="Birimlerimiz" subtitle="Numune Kabul ve Raporlama Birimi" />
  }
/>
<Route
  path="/birimler/fiziksel-analiz"
  element={
    <DynamicContent title="Birimlerimiz" subtitle="Fiziksel Analiz Laboratuvarı" />
  }
/>
<Route
  path="/birimler/kimyasal-analiz"
  element={
    <DynamicContent title="Birimlerimiz" subtitle="Kimyasal Analiz Laboratuvarı" />
  }
/>
            <Route
              path="/birimler/mikro-analiz"
              element={
                <DynamicContent title="Birimlerimiz" subtitle="Mikrobiyoloji Analiz Laboratuvarı"/>
              }
            />

            {/* Belgelerimiz Alt Başlıkları */}
            <Route
  path="/belgeler/akreditasyon-sertifikasi"
  element={
    <DynamicContent title="Belgelerimiz" subtitle="Akreditasyon Sertifikası" />
  }
/>
<Route
  path="/belgeler/akreditasyon-kapsami"
  element={
    <DynamicContent title="Belgelerimiz" subtitle="Akreditasyon Kapsamı" />
  }
/>


            {/* Müşteri Bölümü Alt Başlıkları */}
            <Route
  path="/musteri/analiz-kapsam"
  element={
    <DynamicContent title="Müşteri" subtitle="Analiz Kapsam Listesi" />
  }
/>
<Route
  path="/musteri/numune-kabul"
  element={
    <DynamicContent title="Müşteri" subtitle="Numune Kabul Şartları ve Formu" />
  }
/>

<Route
  path="/musteri/istek-sikayet"
  element={
    <DynamicContent title="Müşteri" subtitle="İstek ve Şikayetler" />
  }
/>
            <Route
  path="/musteri/banka-bilgileri"
  element={
    <div className="container section-container about-us">
      <div className="text-section">
        <h1>Banka Hesap Bilgileri</h1>
        <table className="bank-info-table">
          <tbody>
            <tr>
              <th>Tic. Unvanı / Resmi Adı:</th>
              <td>Şanlıurfa Ticaret ve Sanayi Odası Gıda Araştırma ve Analiz Merkezi Anonim Şirketi</td>
            </tr>
            <tr>
              <th>Vergi Dairesi – Numarası:</th>
              <td>Şehitlik V.D: 7990862600</td>
            </tr>
            <tr>
              <th>Banka/Şube:</th>
              <td>T.C. Ziraat Bankası Şanlıurfa Girişimci Şubesi</td>
            </tr>
            <tr>
              <th>Şirket IBAN No:</th>
              <td>TR420001002266975900775001</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  }
/>


            {/* Ana Başlıklar */}
            <Route
              path="/hakkimizda"
              element={<div className="container">Hakkımızda İçeriği</div>}
            />
            <Route
              path="/birimlerimiz"
              element={<div className="container">Birimlerimiz İçeriği</div>}
            />
            <Route
              path="/belgelerimiz"
              element={<div className="container">Belgelerimiz İçeriği</div>}
            />
            <Route
              path="/musteri-bolumu"
              element={<div className="container">Müşteri Bölümü İçeriği</div>}
            />
            <Route
              path="/iletisim"
              element={<div className="container section-container about-us">
                <div className="text-section">
              <h1>İletişim Bilgileri</h1>
              <h4>Şanlıurfa Ticaret ve Sanayi Odası <br></br> Gıda Araştırma ve Analiz Merkezi A. Ş.</h4>
              <p>📞 Telefon: 0414 318 18 00/6365 - 0539 614 86 01</p>
              <p>📍 Adres: Koçören OSB  Mah. 105. Cad. No:34/1 Eyyübiye/Şanlıurfa</p>
              <p>✉️ E-Posta: info@sutsogaam.org</p>
              </div>
                </div>}

            />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
